// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select-container {
  position: relative;
  box-sizing: border-box;;
}
.custom-select-container * {
  box-sizing: border-box;
}
.custom-select-container.is-disabled {
  opacity: .333;
}
.custom-select-opener {
  background-color: #ccc;
  padding: 0.5em;
  display: block;
  cursor: pointer;
  width: 100%;
}
.custom-select-container select {
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
}
.custom-select-panel {
  max-height: 0;
  transition: max-height .5s ease-out, overflow-y 0.1s 0.5s;
  overflow: hidden;
  background-color: #e9e9e9;
  position: absolute;
  top: 100%;
  z-index: 1;
  width: 100%;
}
.custom-select-container.is-open .custom-select-panel {
  max-height: 10.7em;
  overflow-y: auto
}
.custom-select-option {
  padding: 0.5em;
}
.custom-select-option.has-focus {
  background-color: LightBlue;
}
.custom-select-option.is-selected::before {
  content: "✔";
  padding-right: 0.5em;
}
.custom-select-optgroup > .custom-select-option {
  padding-left: 2em;
}
.custom-select-optgroup::before {
  content: attr(data-label);
  display: block;
  padding: 0.5em;
  color: #888;
}
`, "",{"version":3,"sources":["webpack://./node_modules/custom-select/src/css/custom-select.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,aAAa;EACb,yDAAyD;EACzD,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,WAAW;AACb","sourcesContent":[".custom-select-container {\n  position: relative;\n  box-sizing: border-box;;\n}\n.custom-select-container * {\n  box-sizing: border-box;\n}\n.custom-select-container.is-disabled {\n  opacity: .333;\n}\n.custom-select-opener {\n  background-color: #ccc;\n  padding: 0.5em;\n  display: block;\n  cursor: pointer;\n  width: 100%;\n}\n.custom-select-container select {\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.custom-select-panel {\n  max-height: 0;\n  transition: max-height .5s ease-out, overflow-y 0.1s 0.5s;\n  overflow: hidden;\n  background-color: #e9e9e9;\n  position: absolute;\n  top: 100%;\n  z-index: 1;\n  width: 100%;\n}\n.custom-select-container.is-open .custom-select-panel {\n  max-height: 10.7em;\n  overflow-y: auto\n}\n.custom-select-option {\n  padding: 0.5em;\n}\n.custom-select-option.has-focus {\n  background-color: LightBlue;\n}\n.custom-select-option.is-selected::before {\n  content: \"✔\";\n  padding-right: 0.5em;\n}\n.custom-select-optgroup > .custom-select-option {\n  padding-left: 2em;\n}\n.custom-select-optgroup::before {\n  content: attr(data-label);\n  display: block;\n  padding: 0.5em;\n  color: #888;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
